import {
  LocalDispatch,
  WebChatMiddlewareAction,
  WebChatMiddlewareNext,
} from '../types'

export type { LocalDispatch }

export const currentActionMiddleware =
  (dispatch: LocalDispatch) =>
  () =>
  (next: WebChatMiddlewareNext) =>
  (action: WebChatMiddlewareAction) => {
    const { activity } = action.payload ?? {}

    if (activity && activity.type === 'event' && activity.name === 'action.started') {
      dispatch('UPDATE_CURRENT_ACTION', activity.value)
    }

    if (activity && activity.type === 'event' && activity.name === 'action.ended') {
      dispatch('DISABLE_EDIT_ACTIONS')
    }

    if (activity && activity.type === 'event' && activity.name === 'journey.completed') {
      dispatch('SET_JOURNEY_COMPLETE')
    }

    return next(action)
  }
